import React from 'react';

import { WrapPosition } from './SvgTextItem.styled';

const SvgTextItem = (props) => {
  return (
    <WrapPosition data={props.data} data-html2canvas-ignore={false}>
      <svg viewBox="0 0 300 300">
        <path id="MyPath" fill="none" d={props.data.pos.addPosCss} />
        <text>
          <textPath href="#MyPath" startOffset="50%" textAnchor="middle">
            {props.data.contents}
          </textPath>
        </text>
      </svg>
    </WrapPosition>
  );
};

export default SvgTextItem;



// WEBPACK FOOTER //
// ./src/components/preview/SvgTextItem.tsx